import {InjectionToken, NgModule} from '@angular/core';
import {ActivatedRouteSnapshot, RouterModule, Routes} from '@angular/router';
import {MainMenuComponent} from '../main-menu/main-menu/main-menu.component';
import {SearchPageComponent} from '../object-search/search-page/search-page.component';
import {
  AdvancedSearchComponent
} from '../object-search/advanced-search-and-search-category/advanced-search/advanced-search.component';
import {FaqPageComponent} from '../administration/faq-page/faq-page.component';
import {ImageAnnotationComponent} from '../image-annotation/image-annotation/image-annotation.component';
import {ProcedureComponent} from '../spectrum-procedure/procedure/procedure.component';
import {InformationComponent} from '../information-page/information/information.component';
import {AboutPrimusComponent} from '../administration/about-primus/about-primus.component';
import {AdminMainPageComponent} from '../administration/admin-main-page/admin-main-page.component';
import {AdminSettingsComponent} from '../administration/admin-settings/admin-settings.component';
import {AdminCreateNewComponent} from '../administration/admin-create-new/admin-create-new.component';
import {AdminTemplateGroupComponent} from '../administration/admin-template-group/admin-template-group.component';
import {AdminTemplateModelComponent} from '../administration/admin-template-model/admin-template-model.component';
import {AdminConceptListsComponent} from '../administration/admin-concept-lists/admin-concept-lists.component';
import {
  AdminCollectionComponent
} from '../administration/admin-collection/admin-collection.component';
import {AdminIdFormatComponent} from '../administration/admin-id-format/admin-id-format.component';
import {AdminUsersComponent} from '../administration/admin-users/admin-users.component';
import {
  AdminUsersProfilePageComponent
} from '../administration/admin-users/admin-users-profile-page/admin-users-profile-page.component';
import {AdminLocationComponent} from '../administration/admin-location-place/admin-location/admin-location.component';
import {AdminPlaceComponent} from '../administration/admin-location-place/admin-place/admin-place.component';
import {AuthenticatorComponent} from "../authenticator/authenticator.component";
import {CanDeactivateInformationPage} from '../information-page/can-deactivate-information-page';
import {CanDeactivateProcedurePage} from '../spectrum-procedure/can-deactivate-procedure-page';
import {AdminAgentComponent} from '../administration/admin-agent/admin-agent.component';
import {AdminNamedObjectComponent} from '../administration/admin-named-object/admin-named-object.component';
import {MediaPageComponent} from '../media-page/media-page/media-page.component';
import {ObjectPageComponent} from '../object-page/object-page/object-page.component';
import {CanDeactivateObjectPage} from '../object-page/object-page/can-deactivate-object-page';
import {CanDeactivateMediaPage} from '../media-page/media-page/can-deactivate-media-page';
import {ObjectNewPageComponent} from '../create-object/object-new-page/object-new-page.component';
import {CanDeactivateObjectNewPage} from '../create-object/object-new-page/can-deactivate-object-new-page';
import {AdminServiceComponent} from '../administration/admin-service/admin-service.component';
import {
  AdminServiceFieldsComponent
} from '../administration/admin-service/admin-service-fields/admin-service-fields.component';
import {AdminServiceApiComponent} from "../administration/admin-service/admin-service-api/admin-service-api.component";
import {
  AdminServiceIndexComponent
} from "../administration/admin-service/admin-service-index/admin-service-index.component";
import {NotFoundComponent} from "./not-found/not-found.component";

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
const routes: Routes = [
  {path: 'home', component: MainMenuComponent},
  {path: 'primus', component: MainMenuComponent},
  {
    path: 'search',
    component: SearchPageComponent,
    children: [
      {path: 'advanced-search', component: AdvancedSearchComponent},
      {path: 'artifact', component: ObjectPageComponent, runGuardsAndResolvers: 'always', canDeactivate: [CanDeactivateObjectPage]},
      {path: 'gallery', component: MediaPageComponent, canDeactivate: [CanDeactivateMediaPage]},
      {path: 'video-gallery', component: MediaPageComponent, canDeactivate: [CanDeactivateMediaPage]},
      {path: 'annotate', component: ImageAnnotationComponent},
      {path: 'procedure', component: ProcedureComponent, canDeactivate: [CanDeactivateProcedurePage]},
      {path: 'information', component: InformationComponent, canDeactivate: [CanDeactivateInformationPage]},
    ],
    runGuardsAndResolvers: 'always'
  },
  {path: 'artifact', component: ObjectPageComponent, runGuardsAndResolvers: 'always', canDeactivate: [CanDeactivateObjectPage]},
  {path: 'gallery', component: MediaPageComponent, canDeactivate: [CanDeactivateMediaPage]},
  {path: 'video-gallery', component: MediaPageComponent, canDeactivate: [CanDeactivateMediaPage]},
  {path: 'annotate', component: ImageAnnotationComponent},
  {path: 'procedure', component: ProcedureComponent, canDeactivate: [CanDeactivateProcedurePage]},
  {path: 'information', component: InformationComponent, canDeactivate: [CanDeactivateInformationPage]},
  {path: 'faq', component: FaqPageComponent},
  {path: 'about', component: AboutPrimusComponent},
  {path: 'admin-page', component: AdminCreateNewComponent},
  {path: 'admin', component: AdminMainPageComponent},
  {path: 'settings', component: AdminSettingsComponent},
  {path: 'template-group', component: AdminTemplateGroupComponent},
  {path: 'template-model', component: AdminTemplateModelComponent},
  {path: 'concept-lists', component: AdminConceptListsComponent},
  {path: 'collection', component: AdminCollectionComponent},
  {path: 'id-format', component: AdminIdFormatComponent},
  {path: 'users', component: AdminUsersComponent},
  {path: 'profile', component: AdminUsersProfilePageComponent},
  {path: 'locations', component: AdminLocationComponent},
  {path: 'places', component: AdminPlaceComponent},
  {path: 'agents', component: AdminAgentComponent},
  {path: 'named-object', component: AdminNamedObjectComponent},
  {path: 'service', component: AdminServiceComponent},
  {path: 'fields', component: AdminServiceFieldsComponent},
  {path: 'api', component: AdminServiceApiComponent},
  {path: 'index', component: AdminServiceIndexComponent},
  {path: 'new', component: ObjectNewPageComponent, canDeactivate: [CanDeactivateObjectNewPage]},
  {path: 'authenticate', component: AuthenticatorComponent},
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'externalRedirect', resolve: {url: externalUrlProvider}, component: NotFoundComponent}
];

@NgModule({
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        const externalUrl = route.paramMap.get('externalUrl');
        window.open(externalUrl, '_self');
      }
    }
  ],
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
